<template>
  <div :class="['tasks']">
    <div v-if="istoggle" class="toggle_accordion" @click="accordion()">
      <span class="toggleName">{{getToggleName()}}</span>
      <i :class="['icon_toggle', 'fa', 'fa-angle-up', {'rotate180': !taskGroupOpen}]"></i>
    </div>
    <div v-show="taskGroupOpen" v-for="(taskElement, index) in definition.task" :key="index" :class="[taskElement.taskId, taskElement.type.id]">
      <definition-task-file v-if="taskElement.type.id === 'file'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
      <definition-task-button v-else-if="taskElement.type.id === 'button'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition" @refreshDefinitionContent="refreshDefinitionContent" @taskEnded="taskEnded"
      />
      <definition-task-definition v-else-if="taskElement.type.id === 'definition'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :embeddedDefinition="embeddedDefinition" :builderModifyCall="builderModifyCall" :builderDeleteCall="builderDeleteCall"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex" :callTask="callTask"
        @definitionloaded="definitionloaded" @definitionsaved="definitionsaved" @definitionupdated="definitionupdated" @definitiondeleted="definitiondeleted" @definitionerror="definitionerror" @validatingFormError="validatingFormError"
        @popupClose="popupClose" @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-task-eval v-else-if="taskElement.type.id === 'eval' || taskElement.type.id === 'evalOnChange'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :newEval="popupClosed" :language="language" :authorization="authorization" :type="type" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
      <definition-task-searcher v-else-if="taskElement.type.id === 'searcher' || taskElement.type.id === 'searcherByField'" :key="taskElement.taskId"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :istoggle="istoggle" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-task-refresh v-else-if="taskElement.type.id === 'refresh'"
        :refresh="popupClosed"
        :callTask="callTask"
        @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-task-download v-else-if="taskElement.type.id === 'download'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
      <definition-task-link v-else-if="taskElement.type.id === 'link'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition" @taskLink="taskLink"
      />
      <definition-task-waiting-process v-else-if="taskElement.type.id === 'waitingProcess'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :newEval="popupClosed" :language="language" :authorization="authorization" :type="type" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)" :editRepeatableWaitProcess="editRepeatableWaitProcess"
        @refreshDefinition="refreshDefinition" @waitingProcessFinished="waitingProcessFinished" @waitingProcessInit="waitingProcessInit"
      />
      <definition-task-html-pdf v-else-if="taskElement.type.id === 'html-pdf'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
      <definition-task-tree v-else-if="taskElement.type.id === 'tree'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex" :callTask="callTask"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
    </div>
  </div>
</template>

<script>
import DefinitionTaskFile from './taskFile'
import DefinitionTaskButton from './taskButton'
import DefinitionTaskDefinition from './taskDefinition'
import DefinitionTaskEval from './taskEval'
import DefinitionTaskSearcher from './taskSearcher'
import DefinitionTaskRefresh from './taskRefresh'
import DefinitionTaskDownload from './taskDownload'
import DefinitionTaskLink from './taskLink'
import DefinitionTaskWaitingProcess from './taskWaitingProcess'
import DefinitionTaskHtmlPdf from './taskHtmlPdf'
import DefinitionTaskTree from './taskTree'
import moment from 'moment'

export default {
  name: 'definition-task',
  props: [
    'definition',
    'object',
    'definitionObject',
    'taskRefresh',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'location',
    'repeatableGroupPresentation',
    'embeddedDefinition',
    'builderModifyCall',
    'builderDeleteCall',
    'repeatableItemIndex',
    'calledTaskIndex',
    'editRepeatableWaitProcess',
    'istoggle',
    'callTask'
  ],
  components: {
    DefinitionTaskFile,
    DefinitionTaskButton,
    DefinitionTaskDefinition,
    DefinitionTaskSearcher,
    DefinitionTaskEval,
    DefinitionTaskRefresh,
    DefinitionTaskDownload,
    DefinitionTaskLink,
    DefinitionTaskWaitingProcess,
    DefinitionTaskHtmlPdf,
    DefinitionTaskTree
  },
  data () {
    return {
      task: null,
      popupClosed: null,
      taskGroupOpen: true
    }
  },
  beforeMount () {
    if (this.definition.task) {
      for (var i = 0; i < this.definition.task.length; i++) {
        var task = this.definition.task[i]

        if (task.visual) {
          var visualFound = false
          for (var j = 0; j < this.visuals.length; j++) {
            var visual = this.visuals[j]

            if (visual.id === task.id) {
              visualFound = true
            }
          }

          if (!visualFound) {
            this.visuals.push(JSON.parse(task.visual.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')))
          }
        }
      }
    }
    if (this.istoggle) {
      this.taskGroupOpen = false
    }
  },
  methods: {
    refreshDefinition (object, scope) {
      this.$emit('refreshDefinition', object, scope)
    },
    popupClose () {
      this.popupClosed = moment().valueOf()
    },
    getRepeatableGroupTaskClass (taskId) {
      var result = ''
      if (!this.location || this.location === 'edit') {
        result = this.getRepeatableGroupEditTaskClass(taskId)
      } else if (this.location === 'presentation') {
        result = this.getRepeatableGroupPresentationTaskClass(taskId)
      }
      return result
    },
    getRepeatableGroupEditTaskClass (taskId) {
      var result = ''
      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.tasks && this.repeatableGroupPresentation.tasks.editMode) {
        var found = false
        for (var i = 0; i < this.repeatableGroupPresentation.tasks.editMode.length && !found; i++) {
          var task = this.repeatableGroupPresentation.tasks.editMode[i]
          if (task.taskId === taskId) {
            result = task.class
            found = true
          }
        }
      }
      return result
    },
    getRepeatableGroupPresentationTaskClass (taskId) {
      var result = ''
      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.tasks && this.repeatableGroupPresentation.tasks.presentationMode) {
        var found = false
        for (var i = 0; i < this.repeatableGroupPresentation.tasks.presentationMode.length && !found; i++) {
          var task = this.repeatableGroupPresentation.tasks.presentationMode[i]
          if (task.taskId === taskId) {
            result = task.class
            found = true
          }
        }
      }
      return result
    },
    definitionloaded (content) {
      this.$emit('definitionloaded', content)
    },
    definitionsaved (object, response) {
      this.$emit('definitionsaved', object, response)
    },
    definitionupdated (object, response) {
      this.$emit('definitionupdated', object, response)
    },
    definitiondeleted (object, response) {
      this.$emit('definitiondeleted', object, response)
    },
    definitionerror (error, resultError, container) {
      this.$emit('definitionerror', error, resultError, container)
    },
    validatingFormError () {
      this.$emit('validatingFormError')
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getScopeObject (task) {
      var result
      if (task && task.scope && task.scope === 'full' && this.definitionObject) {
        result = this.definitionObject
      } else {
        result = [this.object]
      }
      return result
    },
    waitingProcessFinished (result, code) {
      this.$emit('waitingProcessFinished', result, code)
    },
    waitingProcessInit () {
      this.$emit('waitingProcessInit')
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    accordion () {
      this.taskGroupOpen = !this.taskGroupOpen
    },
    getToggleName () {
      var result = ''
      if (this.definition.task.length === 1) {
        result = this.definition.task[0].label
      } else {
        result = this.language.seeTasks
      }
      return result
    },
    taskEnded (result) {
      this.$emit('taskEnded', result)
    }
  },
  watch: {
    object: {
      handler: function (val) {
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.groupTasks {
  .tasks > div {
    float: left;
    width: 100%;
    margin-top: 8px;
    text-align: center;
  }

  button {
    width: 100%;
  }
  &.half-task {
    .task {
      width: 50%;
      float: left;
    }
  }
  &.third-task {
    .task {
      width: 33.3333%;
      float: left;
    }
  }
  &.quarter-task {
    .task {
      width: 25%;
      float: left;
    }
  }
  .toggle_accordion {
    cursor: pointer;
    text-align: left;
    font-size: 15px;
    color: #4599a4;

    i.icon_toggle {
      color: #d42e12;
      transition: transform .2s;
      -webkit-transform-: .2s;
      margin-left: 0;
      margin-top: -5px;
      font-size: 18px;
    }
    i.icon_toggle.rotate180 {
      transform: rotate(180deg);
    }
    i {
      font-size: 16px;

      &:before {
        font-weight: 900;
      }
    }
    > span {
      vertical-align: text-bottom;
      font-family: "Source Sans Pro", sans-serif;
      font-weight: 500;
      color: #898989;
    }
  }
}
.taskButton,
.taskDefinition,
.taskLink {
  .w3-buttonTask {
    background-color: #d42e12;
    border: 0;
    width: initial;
    font-family: "Source Sans Pro", sans-serif;;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    vertical-align: middle;
    padding: 7px 10px 4px !important;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 1px;
    height: 40px;

    &:focus {
      outline: 0;
    }

    i.sherpa-icon {
      vertical-align: middle;
      display: inline-block;
      color: #fff;
      text-transform: none;
      font-size: 12px;
    }

    &:hover {
      color: #000;
      transition: all 0.2s ease-in;

      i.sherpa-icon {
        color: #000;
        transition: all 0.2s ease-in;
      }
    }
  }
  .label {
    font-family: "Source Sans Pro", sans-serif;
    padding: 5px 0 10px 55px;

    &.ok_validate {
      color: green;
      font-style: italic;
      font-size: 13px;
      padding-left: 32px;
      font-weight: 100 !important;
    }
  }

  .spinner-loading {
    display: inline-block;
    min-width: 32px;
    vertical-align: sub;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/task/index.vue